export const sheetNames = {
    General: "General",
    Employment: "Employment",
    ValueAdded: "Value added",
    GHG: "GHG",
    Attribution: "Attribution",
};
